import script from "./automatically-followed-banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./automatically-followed-banner.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__